<template>
    <authenticated-layout>

        <div class="d-flex justify-space-between align-center mb-4">
            <h2
                class="font-semibold text-base text-gray-800 leading-tight mx-4"
            >
                #{{ calculator.id }} {{calculator.calculator_id}} {{ calculator.name }} ( {{ calculator.email }} )
            </h2>

            <v-btn
                variant="flat"
                class="ml-2"
                size="small"
                color="primary"
                :href="route('admin-api.index')"
            >
                Back
            </v-btn>
        </div>

        <v-card class="px-4">
            <v-card-title
                class="d-flex justify-space-between align-center p-4"
            >
                <h2
                    class="font-semibold text-base text-gray-800 leading-tight"
                >
                    Information
                </h2>
            </v-card-title>
            <div class="grid grid-cols-12 sm:grid-cols-12 gap-2 p-4">
                <div class="d-flex align-center col-span-3">
                    <span class="font-semibold text-gray-800">Name:</span>
                    <span class="ml-2">{{ calculator.name }}</span>
                </div>
                <div class="d-flex align-center col-span-3">
                    <span class="font-semibold text-gray-800">Email:</span>
                    <span class="ml-2">{{ calculator.email }}</span>
                </div>
                <div class="d-flex align-center col-span-3">
                    <span class="font-semibold text-gray-800">Phone:</span>
                    <span class="ml-2">{{ calculator.phone }}</span>
                </div>

                <div class="d-flex align-center col-span-3">
                    <span class="font-semibold text-gray-800">Address:</span>
                    <span class="ml-2">{{ calculator.address }}</span>
                </div>
            </div>
            <div class="grid grid-cols-12 sm:grid-cols-12 gap-2 p-4">
                <div class="d-flex align-center col-span-12 border">
                    <vue-json-pretty class="w-full" :data="calculator.data" :virtual="true" />
                </div>
            </div>
        </v-card>



    </authenticated-layout>
</template>

<script>
import AuthenticatedLayout from "@/Layouts/Authenticated.vue";
import VueJsonPretty from 'vue-json-pretty';

export default {
    components: {
        AuthenticatedLayout,
        VueJsonPretty
    },
    props: {
        calculator: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            customers: [],
        };
    },
    computed: {

    },
    setup(props) {

    },
    methods: {

    },
};
</script>

<style scoped>
table {
    width: 100%;
    table-layout: fixed;
    font-size: 12px;
}

.zebra-table tr:nth-child(even) {
    background-color: #f2f2f2;
}

@media screen and (max-width: 1024px) {
    table {
        width: auto;
    }
}

th {
    padding: 10px 0px;
    text-align: left;
    box-sizing: border-box;
    padding-left: 10px;
    border-bottom: 1px solid #aaa;
}

td {
    text-align: left;
    box-sizing: border-box;
    padding: 5px 0px;
    padding-left: 10px;
    border-bottom: 1px solid #ccc;
}
</style>
